var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectOtherContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4329 0.3125H3.10278C1.56071 0.3125 0.312012 1.6369 0.312012 3.26949V8.47676C0.312012 8.51927 0.313264 8.56045 0.314518 8.60296C0.313264 8.62421 0.312012 8.64414 0.312012 8.66672V13.4223C0.312012 14.0772 0.818511 14.6259 1.43534 14.5913C1.96691 14.5608 2.40571 14.129 2.4684 13.5632L2.62261 12.171C2.6878 11.5839 3.15794 11.1402 3.71585 11.1402C6.22829 11.1415 12.71 11.1415 12.71 11.1415C14.0979 11.1415 15.2237 9.94861 15.2237 8.47809V3.27081C15.2237 1.6369 13.9737 0.3125 12.4329 0.3125Z",
    fill: "url(#paint0_linear_26286_47640)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_26286_47640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.28985 6.61816H15.1741C16.562 6.61816 17.6878 7.81106 17.6878 9.28158V12.382C17.6878 12.4245 17.6866 12.4657 17.6853 12.5082C17.6866 12.5295 17.6878 12.5494 17.6878 12.572V16.5186C17.6878 17.1921 17.1663 17.7407 16.5319 17.6849C16.0154 17.6398 15.5916 17.2147 15.5302 16.6594C15.3747 15.7256 14.6087 15.0454 13.7148 15.0454C10.914 15.0468 5.28862 15.0468 5.2886 15.0468C5.2886 15.0468 5.2886 15.0468 5.2886 15.0468C3.90074 15.0468 2.7749 13.8539 2.7749 12.3834C2.7749 12.3834 2.7749 10.4041 2.7749 9.28291C2.77616 7.81105 3.90199 6.61816 5.28985 6.61816Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66008 12.1707C7.33449 12.1707 7.8812 11.5914 7.8812 10.8769C7.8812 10.1623 7.33449 9.58301 6.66008 9.58301C5.98568 9.58301 5.43896 10.1623 5.43896 10.8769C5.43896 11.5914 5.98568 12.1707 6.66008 12.1707Z",
    fill: "url(#paint1_linear_26286_47640)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0761 12.1707C10.7505 12.1707 11.2972 11.5914 11.2972 10.8769C11.2972 10.1623 10.7505 9.58301 10.0761 9.58301C9.4017 9.58301 8.85498 10.1623 8.85498 10.8769C8.85498 11.5914 9.4017 12.1707 10.0761 12.1707Z",
    fill: "url(#paint2_linear_26286_47640)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4438 12.1707C14.1182 12.1707 14.6649 11.5914 14.6649 10.8769C14.6649 10.1623 14.1182 9.58301 13.4438 9.58301C12.7694 9.58301 12.2227 10.1623 12.2227 10.8769C12.2227 11.5914 12.7694 12.1707 13.4438 12.1707Z",
    fill: "url(#paint3_linear_26286_47640)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_26286_47640",
    x: -1.054,
    y: 2.78927,
    width: 22.5709,
    height: 18.7281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.91445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26286_47640"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26286_47640",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26286_47640",
    x1: 0.00135183,
    y1: -1.39817,
    x2: 14.4221,
    y2: 15.4362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746EF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26286_47640",
    x1: 5.43896,
    y1: 9.78517,
    x2: 7.88748,
    y2: 11.8813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26286_47640",
    x1: 8.85498,
    y1: 9.78517,
    x2: 11.3035,
    y2: 11.8814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26286_47640",
    x1: 12.2227,
    y1: 9.78517,
    x2: 14.6712,
    y2: 11.8814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectOtherContent);
export default __webpack_public_path__ + "static/media/select-other-content.59f1761697c6eb8a437761180016aa41.svg";
export { ForwardRef as ReactComponent };